module.exports = __webpack_public_path__ + "img/blockS4-3.88fb0da5.svg";